import { render, staticRenderFns } from "./AffiliatesPendingPayoutsList.vue?vue&type=template&id=07e2ba46&"
import script from "./AffiliatesPendingPayoutsList.vue?vue&type=script&lang=js&"
export * from "./AffiliatesPendingPayoutsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports